import { tw } from '@/utils/tw';

const Box = tw.theme({
  base: `group/box box relative flex flex-col empty:hidden`,
});

export default Box;
